import React, { useState } from "react"
import PropTypes from "prop-types"
import { FiSearch, FiX } from "react-icons/fi"
import { navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import { FiAlignJustify, FiXCircle, FiChevronDown } from "react-icons/fi"
import { capitalize } from "../../utils"

const Header = ({ siteTitle, categories }) => {
  const [enableSearch, setEnableSearch] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [openMobile, setOpenMobile] = useState(false)
  const [openCategoryDropdown, setOpenCategoryDropdown] = useState(false)
  const handleEnableSearch = state => {
    setEnableSearch(state)
    setSearchTerm("")
  }

  const handleSearch = value => {
    setSearchTerm(value)
  }

  const handleEnter = e => {
    if (e.key === "Enter") {
      e.preventDefault()
      const searchText = searchTerm
      handleEnableSearch(false)
      navigate(`/search/?s=${searchText}`)
    }
  }

  const handleEnterMobile = e => {
    e.preventDefault()
    const searchText = searchTerm
    handleEnableSearch(false)
    navigate(`/search/?s=${searchText}`)
    setOpenMobile(false)
  }

  return (
    <div className="header">
      <div className="header-wrapper">
        <a href="/">
          {/* <img
            alt={siteTitle}
            src={`/frontendroom.png`}
            className="header--logo"
          /> */}
          <StaticImage
            alt={siteTitle}
            src={`../../images/frontendroom.png`}
            height={60}
            style={{ marginTop: "12px" }}
          />
        </a>
        <div>
          <div className="header-mobile-nav">
            <FiAlignJustify
              size="24"
              style={{ cursor: "pointer", color: "#A12626" }}
              onClick={() => setOpenMobile(true)}
            />
            {openMobile && (
              <div className="mobile-drop">
                <div className="mobile-top-wrapper">
                  <div className="mobile-top-logo-wrapper">
                    <StaticImage
                      alt={siteTitle}
                      src={`../../images/frontendroom.png`}
                      height={48}
                      style={{ marginTop: "12px" }}
                    />
                    <div>
                      <FiXCircle
                        size="24"
                        style={{ cursor: "pointer", color: "#A12626" }}
                        onClick={() => setOpenMobile(false)}
                      />
                    </div>
                  </div>
                  <div className="mobile-search-wrapper">
                    <input
                      value={searchTerm}
                      onChange={e => handleSearch(e.target.value)}
                      className="mobile-search-input"
                    />
                    <button
                      onClick={handleEnterMobile}
                      className="mobile-search-button"
                    >
                      Search
                    </button>
                  </div>
                  <div className="mobile-mid-wrapper">
                    <a href="/tools/">Tools</a>
                    <ul className="mobile--category">
                      {categories?.map(category => {
                        return (
                          <li className="mobile--category--item" key={category}>
                            <a href={`/category/${category}/`}>
                              {capitalize(category)}
                            </a>
                          </li>
                        )
                      })}
                    </ul>
                    <a href="/shorts/">Shorts</a>
                    <a href="/about-us/">About</a>
                  </div>
                </div>
              </div>
            )}
          </div>
          {!enableSearch ? (
            <div className="header-desktop-nav">
              <a href="/tools/" className="desktop--nav-item">
                Tools
              </a>
              <div className="desktop--nav-item--wrapper">
                <span
                  className="desktop--nav-item"
                  onClick={() => setOpenCategoryDropdown(state => !state)}
                  role="presentation"
                >
                  Categories{" "}
                  <FiChevronDown size="24" style={{ color: "#A12626" }} />
                </span>
                {openCategoryDropdown ? (
                  <div className="desktop--nav-item--dropdown">
                    <ul className="mobile--category">
                      {categories?.map(category => {
                        return (
                          <li className="mobile--category--item" key={category}>
                            <a href={`/category/${category}/`}>
                              {capitalize(category)}
                            </a>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                ) : null}
              </div>
              <a href="/shorts/" className="desktop--nav-item">
                Shorts
              </a>
              <a href="/about-us/" className="desktop--nav-item">
                About
              </a>
              <div className="desktop--nav-item">
                <FiSearch onClick={() => handleEnableSearch(true)} size={24} />
              </div>
            </div>
          ) : (
            <div className="desktop-search--wrapper">
              <div className="desktop--wrapper">
                <input
                  value={searchTerm}
                  onChange={e => handleSearch(e.target.value)}
                  onKeyPress={handleEnter}
                  className="desktop-search-input"
                />
                {searchTerm ? (
                  <FiX size={24} onClick={() => handleSearch("")} />
                ) : null}
              </div>
              <FiX
                onClick={() => handleEnableSearch(false)}
                size={24}
                className="desktop-search--x"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
